import { render, staticRenderFns } from "./RepairServiceService.vue?vue&type=template&id=2e856fd6"
import script from "./RepairServiceService.vue?vue&type=script&lang=js"
export * from "./RepairServiceService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports